module.exports = __webpack_public_path__ + "static/media/furnishedlivingla-logo-71618.6d2a5f15.png";


//////////////////
// WEBPACK FOOTER
// ./src/furnishedlivingla-logo-71618.png
// module id = 107
// module chunks = 0